export default __webpack_public_path__ + "static/media/c003-man-left.1a4de08d.png";